var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontbigsmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,215.1c-4.4-0.6-8.7-1.4-13,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.8,241.6c-4,0.7-8,1.9-12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.8,196.1c2.4,4,5.5,7.8,4.5,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.8,251.6c-1.1,4-0.4,8-0.5,12c-0.1,8.8-0.2,17.7,0,26.5c0.2,15.5-5.6,28.5-15.6,40c-3.4,3.9-7.3,7.4-11,11 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,215.1c6.4,8.1,15.3,12.4,25,14.4c17.4,3.5,33-0.5,46.5-12.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.8,252.1c1.1,12.8,0.4,25.7,0.4,38.5c0,11.9,2.8,22.8,8.9,33.1c3.9,6.6,8.6,11.9,15.1,16 c1.9,1.2,4.5,2,5.6,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.3,197.6c-2.7,3.4-4.6,7-4,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.8,215.1c3-1,6-0.5,9-0.5c11.7-0.1,23.3,0,35,0c1.9,0,4.1-0.8,5.2,1.9c3.5-3.5,6.3-6.9,8.7-10.9 c-0.9-0.4-1.4-1-1.9-0.9c-17.9,0.7-35.7-2.3-53.5-0.8c-11,0.9-22,0.1-33.4,1.1c2,3.8,4.3,6.8,6.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.3,81.1c0,21.5-0.1,43,0,64.5c0.3,36.9-11.8,69.2-37.2,95.9c-12,12.6-26.2,22.9-43.9,26.6 c-9.7,2-19.1,0.3-28-3.9c-16.1-7.8-28.7-19.6-39-34c-10.1-14.1-17.5-29.6-21.5-46.5c-1.9-8.2-3.6-16.5-3.6-25c0-21.7,0-43.3,0-65 c0-4.2-0.3-8.3-0.5-12.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontbigsmile);
export default __webpack_public_path__ + "static/media/frontbigsmile.3dc92918f72637114b6bf975298df57f.svg";
export { ForwardRef as ReactComponent };